function fn_comp_map() {
    var $fn = $(".comp_map");
    $fn.find("[data-map]").nl_leaflet_map();
}